import { render, staticRenderFns } from "./transactionHold.vue?vue&type=template&id=4dbbf580&"
import script from "./transactionHold.vue?vue&type=script&lang=js&"
export * from "./transactionHold.vue?vue&type=script&lang=js&"
import style0 from "./transactionHold.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports